import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie } from 'lucide-react';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('bsg_cookies');
    if (!accepted) {
      const t = setTimeout(() => setVisible(true), 1400);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('bsg_cookies', 'accepted');
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 60, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 60, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-6 right-6 z-[70] max-w-sm glass rounded-2xl p-5 shadow-2xl"
        >
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-full bg-[#d5b56b]/10 border border-[#d5b56b]/30 grid place-items-center shrink-0">
              <Cookie size={18} className="text-[#d5b56b]" />
            </div>
            <div>
              <h4 className="font-serif text-lg text-[#eef1f8] leading-tight">This site uses cookies.</h4>
              <p className="text-xs text-[#eef1f8]/60 mt-2 leading-relaxed">
                We use cookies to analyze traffic and optimize your experience. By accepting,
                your data will be aggregated with all other user data.
              </p>
              <button
                onClick={accept}
                className="mt-4 w-full text-xs tracking-[0.2em] uppercase py-2.5 rounded-full bg-[#0a1230] text-[#eef1f8] border border-[#d5b56b]/30 hover:bg-[#d5b56b] hover:text-[#0a1230] transition-all duration-300"
              >
                Accept
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
